import "./text.css"

export const Text = () => {
    return(
        <div className="textContainer">
            <h1>GO FAIR Agro</h1>
            <p>Rede de Implementação Temática GO FAIR Agro será responsável por elaborar estratégias e mobilizar parcerias para a implantação dos princípios FAIR no universo dos dados da pesquisa agropecuária brasileira, ou seja, desenvolver metodologias e soluções para que os dados, que hoje se encontram dispersos, sejam interoperáveis do ponto de vista tecnológico e semântico, respeitando as especificidades dos diferentes domínios do conhecimento agropecuário e fomentando assim a pesquisa e a inovação intensiva em dados.</p>
            <p>A Rede GO FAIR Agro Brasil é uma rede de implementação temática que se propõe a fortalecer a disseminação dos princípios FAIR no campo das ciências agrárias.</p>
        </div>
    );
}